module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fillcontain"
  }, [_c('div', {
    staticClass: "navCalss",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("| 货物价格")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-flexRight"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openAdd()
      }
    }
  }, [_vm._v("新增货物类型")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": "",
      "size": "medium"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodName",
      "label": "货物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格系数",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.price) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "是否计算首重",
      "min-width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.firstWeight) ? _c('span', [_vm._v(" 是 ")]) : _c('span', [_vm._v(" 否 ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operatorTime",
      "label": "操作时间",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onDel(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("移除")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialog.title,
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "netBar",
    staticStyle: {
      "margin": "20px",
      "width": "auto"
    },
    attrs: {
      "model": _vm.priceGoods.netBarForm,
      "rules": _vm.priceGoods.form_rules,
      "label-width": _vm.priceGoods.formLabelWidth,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "货物类型:",
      "prop": "goodType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请选择货物类型",
      "filterable": ""
    },
    model: {
      value: (_vm.priceGoods.netBarForm.goodType),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "goodType", $$v)
      },
      expression: "priceGoods.netBarForm.goodType"
    }
  }, _vm._l((_vm.priceGoods.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "goodName",
      "label": "类型名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入类型名称"
    },
    model: {
      value: (_vm.priceGoods.netBarForm.goodName),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "goodName", $$v)
      },
      expression: "priceGoods.netBarForm.goodName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格系数:",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入价格系数"
    },
    model: {
      value: (_vm.priceGoods.netBarForm.price),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "price", $$v)
      },
      expression: "priceGoods.netBarForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计算首重:",
      "prop": "firstWeight"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.priceGoods.netBarForm.firstWeight),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "firstWeight", $$v)
      },
      expression: "priceGoods.netBarForm.firstWeight"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入备注(选填)"
    },
    model: {
      value: (_vm.priceGoods.netBarForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "remark", $$v)
      },
      expression: "priceGoods.netBarForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 150px"
    }
  }, [(_vm.showOnsub) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsumbit()
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: _vm.showOnsub ? '' : 'margiLeft',
    on: {
      "click": function($event) {
        _vm.dialog.show = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定删除该货物类型信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteGoods(_vm.galObj)
      }
    }
  }, [_vm._v("移除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.showB = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c905f20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/freightage/priceGoods.vue
// module id = 1234
// module chunks = 2